import { Link } from "react-router-dom";

export default function CancelPage() {
  return (
    <main data-testid="cancel-page" className="min-h-screen bg-cream flex items-center justify-center px-6 py-24">
      <div className="max-w-2xl w-full text-center">
        <p className="smallcaps text-ink-soft mb-8">Pagamento cancelado</p>
        <h1 className="font-serif-display text-4xl md:text-6xl text-ink leading-[1.05] mb-12">
          Sem problema.<br />
          <em className="text-accent font-normal">Volta quando estiveres pronta.</em>
        </h1>
        <Link
          to="/#comprar"
          data-testid="cancel-back-link"
          className="btn-accent inline-block px-10 py-4 rounded-sm uppercase text-sm"
        >
          Voltar ao workbook
        </Link>
      </div>
    </main>
  );
}
